import React, { useState } from 'react';
import { MenuItem, Grid, makeStyles, FormControlLabel } from '@material-ui/core';
import Select from './Select';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { useMediaQuery } from '@mui/material';
import Switch from './Switch';

const useStyles = makeStyles((theme) => ({
  customTextField: {
    '& .MuiInputBase-input': {
      height: '35px',
    },
  },
  select: {
    borderRadius: '17px',
    backgroundColor: 'lightgrey',
  },
}));

export default function CommissionAndFees({ services, setServices, residualProvider, updateProvider }) {
  const classes = useStyles();
  const isSmallScreen = useMediaQuery('(max-width:599px)')
  const isTabScreen = useMediaQuery('(min-width:600px) and (max-width:1279px)');
  const [providerPays, setProviderPays] = useState<number>(1);
  const [customPer, setCustomPer] = useState<Record<string, string>>({});

  const handleSelectionChange = (id: string, value: number) => {
    setCustomPer({ ...customPer, [id]: '' });
    setServices({
      ...services,
      [id]: {
        ...services[id],
        percentage: value,
      },
    });
  };

  const handlesubmit = (e, id: string, value: number) => {
    e.preventDefault();
    setServices({
      ...services,
      [id]: {
        ...services[id],
        percentage: Number(customPer[id]) || value
      },
    });
  };

  const handleChangePer = (id: string, value: string | number) => {
    if (Number(value) > 100) {
      value = '100';
    }
    if (Number(value) < 0) {
      value = '';
    }
    setCustomPer({ ...customPer, [id]: value as string });
    setServices({
      ...services,
      [id]: {
        ...services[id],
        percentage: Number(value)
      },
    });
  };

  const handleSwitchInput = (attr: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.checked;
    updateProvider(attr, value)
  };

  return (
    <>
      <Grid item >
        <FormControlLabel
          label="Enable Upkeep Paying Processing Fees?"
          control={
            <Switch checked={residualProvider('isUpkeepPayingProcessingFees') || false} onChange={handleSwitchInput('isUpkeepPayingProcessingFees')}/>
          }
        />
      </Grid>
      {Object.keys(services).map((id) => {
        const service = services[id];
        const customValue = customPer[id] ?? '';
        const isStandardPercentage = Number(service.percentage) === 15 || Number(service.percentage) === 20;
        return (
          <Grid container direction="row" justifyContent="space-between" alignItems="center" key={id}>
            <Grid item xs={12} lg={6}>
              <div style={{ marginLeft: '1rem' }}>{service.name}</div>
            </Grid>
            <Grid item xs={6} lg={2} style={{}}>
              <Select
                key={id}
                labelId={id}
                id={id}
                classes={{ select: customValue.length > 0 || (service.percentage !== 15 && service.percentage !== 20) ? classes.select : null }}
                onChange={(event) => handleSelectionChange(id, event.target.value)}
                defaultValue={20}
                value={customValue || service.percentage}>
                <MenuItem style={{ fontFamily: 'Poppins' }} key={15} value={15}>
                  15 %
                </MenuItem>
                <MenuItem style={{ fontFamily: 'Poppins' }} key={20} value={20}>
                  20 %
                </MenuItem>
              </Select>

            </Grid>
            <Grid item xs={6} lg={2}>
              <TextField
                key={id}
                id={id}
                sx={{ ml: 2, mt: '10px' , ...(isTabScreen && {
                  width: '100%'
                })}}
                label="Custom%"
                variant="outlined"
                type="Number"
                InputProps={{
                  className: classes.customTextField,
                }}
                value={(customValue.length > 0 || isStandardPercentage ? customValue : service.percentage) || ''}
                onChange={(e) => handleChangePer(id, e.target.value)}
                size="small"
              />
            </Grid>
            <Grid item xs={12} lg={2} >
              <Button
                sx={{
                  ml: 2,
                  mt: '10px',
                  height: '45px',
                  backgroundColor: '#348D84',
                  color: 'white',
                  ':hover': {
                    bgcolor: '#348D84',
                    color: 'white',
                  },
                  ...(isSmallScreen && {
                    marginBottom: '10px',
                    marginLeft: '65%'
                  }),
                  ...(isTabScreen && {
                    marginLeft: '85%'
                  })
                }}
                variant="contained"
                onClick={(e) => handlesubmit(e, id, service.percentage)}>
                Submit
              </Button>
            </Grid>
          </Grid>
        );
      })}
      {/* <Typography style={{ marginTop: '2rem' }}>Provider pays fees?</Typography> */}
      <Select labelId="pay" id="pay" value={providerPays} onChange={(event) => setProviderPays(event.target.value)}>
        {/* <MenuItem style={{ fontFamily: 'Poppins' }} key={`yes`} value={`yes`}>
          Yes
        </MenuItem> */}
        {/* <MenuItem style={{ fontFamily: 'Poppins' }} key={`no`} value={`no`}>
          No
        </MenuItem> */}
      </Select>
    </>
  );
}
